
  export default {
    name: 'WjHomesite',
    mounted() {
      window.kuo = this
      console.log(this)
    },
  }
